<template>
  <transition name="fade" mode="out-in" appear>
    <div class="comp-modal-confirm">
      
      <div
      v-on:click="onClickBackground" ontouchstart=""
      class="modal-background"></div>

      <div class="modal-window">

        <div class="modal-header">
          <div class="modal-header-title" v-html="confirmDescription"></div>
        </div>

        <div class="modal-body">

          <div
          v-on:click="onClickCancel" ontouchstart=""
          class="modal-action-btn close">
            <div class="btn-text" v-html="cancelString"></div>
          </div>
          <div
          v-bind:class="{
            gray: !isDangerous,
            red: isDangerous
          }"
          v-on:click="onClickConfirm" ontouchstart=""
          class="modal-action-btn">
            <div class="btn-text">{{confirmString}}</div>
          </div>

        </div>

      </div>

    </div>
  </transition>
</template>

<script>
export default {
  name: 'comp-modal-confirm',
  props: {
    cancelString: {
      type: String,
      default: function () {
        return 'Cancel'
      }
    },
    confirmString: {
      type: String,
      default: function () {
        return 'Proceed'
      }
    },
    confirmDescription: {
      type: String,
      default: function () {
        return 'Do you want to proceed?'
      }
    },
    isDangerous: {
      type: Boolean,
      default: function () {
        return false
      }
    }
  },
  data: function () {
    return {
    }
  },
  created: function () {
  },
  computed: {
  },
  methods: {
    onClickCancel: function () {
      this.$emit('onClose', {
        isToProceed: false
      })
    },
    onClickConfirm: function () {
      this.$emit('onClose', {
        isToProceed: true
      })
    },
    onClickBackground: function () {
      this.onClickCancel()
    }
  }
}
</script>

<style lang="scss" scoped>
.comp-modal-confirm {
  /* size */
  width: 100%;
  height: 100%;
  /* position */
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
}

.comp-modal-confirm .modal-background {
  /* common */
  background-color: hsla(0, 0%, 0%, 1);
  opacity: 0.8;
  /* size */
  width: 100%;
  height: 100%;
  /* position */
  position: absolute;
  top: 0;
  left: 0;
}

.comp-modal-confirm .modal-window{
  /* common */
  overflow: hidden;
  background: #212121;
  box-shadow: 0 0 20px 2px rgba(0,0,0,0.5);
  color: hsla(0,100%,100%,0.87);
  /* text */
  text-align: center;
  /* shape */
  border-radius: 6px;
  /* size */
  max-width: 400px;
  width: calc(100% - 40px);
  /* position */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.comp-modal-confirm .modal-header{
  /* common */
  color: hsla(0,100%,100%,0.87);
  /* size */
  padding: 2em 1em 3em 1em;
  /* alignment */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}


.comp-modal-confirm .modal-header .modal-header-title{
  /* common */
  font-size: 1.5em;
  /* size */
  width: 100%;
}

.comp-modal-confirm .modal-body{
  /* common */
  color: hsla(0,100%,100%,0.87);
  /* alignment */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin: 0px 20px 20px 20px;
}

.comp-modal-confirm .modal-action-btn{
  /* size */
  padding: 1em;
  height: 45px;
  /* mouse */
  cursor: pointer;
  /* text */
  text-align: center;
  font-weight: bold;
  text-transform: uppercase;
  /* size */
  width: calc(50%);
  border-radius: 5px;
  /* alignment */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  &.close {
    color: hsla(0,100%,100%,0.87);
    background-color: #353434;
    &:hover {
      background-color: #494848;
    }
    &:active {
      background-color: #2f2e2e;
    }
  }

  &.gray {
    color:  hsla(0,100%,100%,0.87);
    background-color: #6D6D6D;
    &:hover {
      background-color: #7c7c7c;
    }
    &:active {
      background-color: #606060;
    }
  }
  &:not(:first-child) {
    margin-left: 10px;
  }
}
.comp-modal-confirm .modal-action-btn:hover{
  /* common */
  background-color: rgba(0,0,0,0.04);
}
.comp-modal-confirm .modal-action-btn:active{
  /* common */
  background-color: rgba(0,0,0,0.08);
}
.comp-modal-confirm .modal-action-btn.white{
  /* common */
  color: hsla(0,100%,100%,0.87);
  background-color: rgb(255, 255, 255);
}
.comp-modal-confirm .modal-action-btn.white:hover{
  /* common */
  background-color: rgba(255, 255, 255, 0.03);
}
.comp-modal-confirm .modal-action-btn.white:active{
  /* common */
  background-color: rgba(255, 255, 255, 0.06);
}
.comp-modal-confirm .modal-action-btn.blue{
  /* common */
  color: hsla(0,100%,100%,0.87);
  background-color: rgba(7,171,254, 0.9);
}
.comp-modal-confirm .modal-action-btn.blue:hover{
  /* common */
  background-color: rgba(7,171,254, 0.95);
}
.comp-modal-confirm .modal-action-btn.blue:active{
  /* common */
  background-color: rgba(7,171,254, 1);
}
.comp-modal-confirm .modal-action-btn.red{
  /* common */
  color: hsla(0,100%,100%,0.87);
  background-color:#CD3D64;
}
.comp-modal-confirm .modal-action-btn.red:hover{
  /* common */
  background-color: #D25074;
}
.comp-modal-confirm .modal-action-btn.red:active{
  /* common */
  background-color: #B43658;
}

.comp-modal-confirm .modal-action-btn.disabled{
  /* common */
  opacity: 0.5;
}

</style>



// WEBPACK FOOTER //
// src/components/CompModalConfirm.vue